import React, { useState, useEffect, useContext, lazy, useMemo } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useParams } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
// Components
import MenuBtn from "./components/menubtn/menubtn";
import ThemeContext from "../theme/components/contexts/themecontexts";
// Style
import "./assets/css/header.scss";
// Images
import { logout } from "../../../actions/login/authActions";
import NavDropdown from "react-bootstrap/NavDropdown";
// import LogoDark from "./assets/img/resta-logo.svg";
// import LogoLight from "./assets/img/resta-logo-white.png";
import { getFooter } from "../../../actions/home/footerAction";
import { getSocial } from "../../../actions/home/socialAction";
import { getMenuImage } from "../../../actions/home/menuImageAction";
import { getAboutUs } from "../../../actions/home/aboutAction";
import { getMealDeal } from "../../../actions/home/mealDealAction";
import { getHomepage } from "../../../actions/home/homepageActions";
import { getGallery } from "../../../actions/home/galleryAction";
import { getSignup } from "../../../actions/home/signupAction";
import { getFeedBack } from "../../../actions/home/feedBackAction";
import { getReview } from "../../../actions/home/reviewAction";
import { getMainTableBooking } from "../../../actions/home/mainTableBookingAction";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import Loadable from "../router/loadable";
import { OrderFlow } from "../../../App";
import { FaUserCircle } from "react-icons/fa";
import { MdAccountBalanceWallet } from "react-icons/md";
import { IoMdExit } from "react-icons/io";
import { login, setLoggedIn } from "../../../actions/login/authssoActions";
import { Helmet } from "react-helmet-async";
import { GiShoppingBag } from "react-icons/gi";
import { subcribePlanOrder } from "../../../actions/subscribe/subscribePlanAction";
import ActivationPopup from "../accountActivation/activationPopup";
import { getTableGalleryDetail } from "../../../actions/menu/tablegalleryAction"
import { jwtDecode } from 'jwt-decode';
import { useSelector } from "react-redux";
import PopupCurrency from "../../currency/currencyPopup";

const SignIn = Loadable(lazy(() => import("../../../pages/sign-in/sign-in")));
const Subscription = Loadable(lazy(() => import('../../../pages/subscription/subscriptionPoup')));

const Header = ({
  login,
  isLoggedIn,
  userData,
  logout,
  response,
  menuImage,
  home
}) => {

  const [getUrlLink, setUrlLink] = useState();
  const [getImageUrl, setImageUrl] = useState();
  // changes of SEO
  const [getImageAlt, setImageAlt] = useState();
  const [showAboutUs, setShowAboutUs] = useState(true);
  const [showMealDealMenu, setShowMealDealMenu] = useState(true);
  const [showGallery, setShowGallery] = useState(true);
  const [showBookTable, setShowBookTable] = useState(true);
  const [showReview, setShowReview] = useState(true);
  const location = useLocation();
  const reduxDispatch = useDispatch();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [tableGalleryButton, setTableGalleryButton] = useState(null);
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    console.log(searchQuery);
  };
  const {
    moveToCheck,
    setMoveToCheck,
    setLogo,
    setHeaderButtonResponse,
    setOneTabShow,
    setCartButtonText,
    setContactUsButtonText,
    setOrderNowButtonText,
    setSubscriptionButtonText,
    setFranchiseButtonText,
    setCartButtonURL,
    setContactUsButtonURL, setFranchiseButtonURL,
    setOrderNowButtonURL,
    setSubscriptionButtonURL
  } = OrderFlow();
  const apiResponse = localStorage.getItem("apiRes");

  // const queryParams = new URLSearchParams(location.search);
  // const googleLoginParam = queryParams.get("google_login");
  const showOrderNowButton = !location.pathname.endsWith("/menu");
  const dispatch = useDispatch();
  const { path } = useParams();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = new URL("https://api-new.fusionkitchen.co.uk/homePage");
        const domain = window.location.hostname;
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: JSON.stringify({ domain }),
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch: ${response.statusText}`);
        }

        const data = await response.json();

        if (data?.data) {
          let root = document.documentElement;
          if ((data?.data?.theme)) {
            const { background, color } = data?.data?.theme;
            // Set CSS variables based on the response theme
            root.style.setProperty("--theme-background", background);
            root.style.setProperty("--theme-color", color);
            // Set a special color if the main color is white
            if (color === "#ffffff") {
              root.style.setProperty("--theme-color-only", background);
            } else {
              root.style.setProperty("--theme-color-only", color);
            }
          }
          if (data?.data?.header?.navbar) {
            const { foregroundColor, backgroundColor } = data?.data?.header?.navbar;
            console.log(foregroundColor, backgroundColor, "3333");

            root.style.setProperty("--theme-navbar-background", backgroundColor);
            root.style.setProperty("--theme-navbar-color", foregroundColor);
          }
          if (data?.data?.header?.buttonCss) {
            const backgroundColor = data?.data?.header?.buttonCss?.orderNowButtonBackgroundColor;
            const foregroundColor = data?.data?.header?.buttonCss?.orderNowButtonForegroundColor;
            root.style.setProperty("--theme-nav-btn-background", backgroundColor);
            root.style.setProperty("--theme-nav-btn-color", foregroundColor);
          }
          if (data?.data?.header?.font) {
            const font_family_name = data?.data?.header?.font?.font_family_name;
            document.documentElement.style.setProperty('--theme-font-family', font_family_name);
          }
        } else {
          console.warn('No theme data found in the response.');
        }

      } catch (error) {
        console.error("Error during API call:", error);
        // Optionally show an alert or set a state to display an error message
        // alert("An error occurred while fetching the theme data.");
      }
    };

    // Call the async function
    fetchData();
  }, []);
  // Empty dependency array ensures this effect runs only once on mount

  useEffect(() => {
    if (
      userData &&
      userData.status &&
      userData.customerId &&
      (userData.login_type == 1 || userData.login_type == 2)
    ) {
      reduxDispatch(setLoggedIn());
      setOneTabShow(false);
      // navigate('/');
    }
  }, [userData]);

  useEffect(() => {
    const extractParameters = () => {
      const queryParams = new URLSearchParams(window.location.search);
      const googleLoginParam = queryParams.get("google_login");
      const facebookLoginParam = queryParams.get("facebook_login");
      const appleLoginParam = queryParams.get("apple_login");

      if (googleLoginParam === "1") {
        queryParams.delete("google_login");
        const remainingParams = {};
        queryParams.forEach((value, key) => {
          remainingParams[key] = value;
        });
        localStorage.setItem("google_login", JSON.stringify(remainingParams));

        const googleDetailsString = localStorage.getItem("google_login");
        const googleDetails = JSON.parse(googleDetailsString);
        const postData = {
          verfication_code: googleDetails.id,
          email: googleDetails.email,
          login_type: 1,
          first_name: googleDetails.given_name,
          last_name: googleDetails.family_name,
        };
        console.log(postData);
        login(JSON.stringify(postData));
        const path = localStorage.getItem("clientPath");
        if (moveToCheck && location.pathname.includes("/menu")) {
          setMoveToCheck(false);
          localStorage.setItem("moveToCheck", false);
          navigate(`/${path}/checkout`);
        } else {
          if (location.pathname.includes("/app")) {
            // navigate('/');
            window.location.href = "/"
          }
          else {
            navigate(window.location.pathname);
          }
        }

        // window.history.replaceState({}, document.title, newUrl);
      } else if (facebookLoginParam === "1") {
        queryParams.delete("facebook_login");
        const remainingParams = {};
        queryParams.forEach((value, key) => {
          remainingParams[key] = value;
        });
        localStorage.setItem("facebook_login", JSON.stringify(remainingParams));

        const facebookDetailsString = localStorage.getItem("facebook_login");
        const facebookDetails = JSON.parse(facebookDetailsString);
        const postData = {
          verfication_code: facebookDetails["facebook_data[FBID]"] || "",
          email: facebookDetails["facebook_data[EMAIL]"] || "",
          login_type: 2,
          first_name: facebookDetails["facebook_data[F_NAME]"] || "",
          last_name: facebookDetails["facebook_data[L_NAME]"] || "",
        };
        login(JSON.stringify(postData));
        const path = localStorage.getItem("clientPath");
        if (moveToCheck && location.pathname.includes("/menu")) {
          setMoveToCheck(false);
          localStorage.setItem("moveToCheck", false);
          navigate(`/${path}/checkout`);
        } else {
          if (location.pathname.includes("/app")) {
            // navigate('/');
            window.location.href = "/"
          }
          else {
            navigate(window.location.pathname);
          }
        }
      } else if (appleLoginParam === "1") {
        queryParams.delete("apple_login");
        const remainingParams = {};
        queryParams.forEach((value, key) => {
          remainingParams[key] = value;
        });
        localStorage.setItem("apple_login", JSON.stringify(remainingParams));
        const appleDetailsString = localStorage.getItem("apple_login");
        const googleDetails = JSON.parse(appleDetailsString);
        console.log(googleDetails);

        const decodedToken = jwtDecode(googleDetails.code);
        console.log(decodedToken);
        const email = decodedToken.email;
        const firstName = '';
        const lastName = '';
        const postData = {
          verfication_code: decodedToken.c_hash,
          login_type: 4,
          email: email,
          first_name: firstName,
          last_name: lastName,
        };

        login(JSON.stringify(postData));
        const path = localStorage.getItem("clientPath");
        if (moveToCheck && location.pathname.includes("/menu")) {
          setMoveToCheck(false);
          localStorage.setItem("moveToCheck", false);
          navigate(`/${path}/checkout`);
        } else {
          if (location.pathname.includes("/app")) {
            // navigate('/');
            window.location.href = "/"
          }
          else {
            navigate(window.location.pathname);
          }
        }

      } else {
        localStorage.setItem("google_login", "");
        localStorage.setItem("facebook_login", "");
        localStorage.setItem("apple_login", "");
      }
    };

    extractParameters();
  }, []);

  useEffect(() => {
    if (response) {
      setUrlLink(response?.data?.header?.orderNowLink);
      setImageUrl(response?.data?.header?.logoImage);
      setImageAlt(response?.data?.header?.businessName);
      setLogo(response?.data?.header?.b2cLogo);
      const pageConfig = response?.data?.pageConfig;
      setShowMealDealMenu(pageConfig?.mealDeal !== 0);
      setShowAboutUs(pageConfig?.aboutUs !== 0);
      setShowGallery(pageConfig?.gallery !== 0);
      setShowBookTable(pageConfig?.bookTable !== 0);
      setShowReview(pageConfig?.review !== 0);
      setHeaderButtonResponse(response?.data?.header?.button);
      const buttonTextConfig = response?.data?.header?.buttonText;
      const navCartBtn = buttonTextConfig?.cartButton ? buttonTextConfig?.cartButton : "CART";
      const navContactBtn = buttonTextConfig?.contactUsButton ? buttonTextConfig?.contactUsButton : "CONTACT US";
      const franchiseBtn = buttonTextConfig?.franchiseButton ? buttonTextConfig?.franchiseButton : "BECOME FRANCHISE";
      const navorderNowBtn = buttonTextConfig?.orderNowButton ? buttonTextConfig?.orderNowButton : "ORDER NOW";
      const navsubscriptionBtn = buttonTextConfig?.subscriptionButton ? buttonTextConfig?.subscriptionButton : "SUBCRIPTION";
      setCartButtonText(navCartBtn);
      setContactUsButtonText(navContactBtn);
      setFranchiseButtonText(franchiseBtn)
      setOrderNowButtonText(navorderNowBtn);
      setSubscriptionButtonText(navsubscriptionBtn);
      //button url
      const path = localStorage.getItem("path");
      const buttonURLConfig = response?.data?.header?.buttonLink;
      const navCartURL = buttonURLConfig?.cartButton ? buttonURLConfig.cartButton : path + "/menu";
      const navContactURL = buttonURLConfig?.contactUsButton ? buttonURLConfig.contactUsButton : "/#contact-nav";
      const navFranchiseURL = buttonURLConfig?.franchiseButton ? buttonURLConfig.franchiseButton : "/become-franchise";
      const navorderNowURL = buttonURLConfig?.orderNowButton ? buttonURLConfig.orderNowButton : path + "/menu";
      const navsubscriptionURL = buttonURLConfig?.subscriptionButton ? buttonURLConfig.subscriptionButton : "";
      setCartButtonURL(navCartURL);
      setContactUsButtonURL(navContactURL);
      setFranchiseButtonURL(navFranchiseURL);
      setOrderNowButtonURL(navorderNowURL);
      setSubscriptionButtonURL(navsubscriptionURL);
      localStorage.setItem("configLogo", response?.data?.header?.b2cLogo);
    }
  }, [response]);

  const handleLogout = () => {
    const discountJSON = localStorage.getItem("discount");
    const discount = discountJSON ? JSON.parse(discountJSON) : "";
    localStorage.clear("SubcripeCoupon");
    reduxDispatch(subcribePlanOrder());
    localStorage.clear("subscribePlan");
    if (discount?.source == "SubscriptionCoupon") {
      localStorage.clear("discount");
    }
    logout();
    if (location.pathname.includes("/checkout")) {
      navigate(-1);
    } else if (!location.pathname.includes("/menu")) {
      navigate("/");
    }
  };
  // const feedBackSelector=useSelector((state)=>state.feedBack.response);
  // useEffect(()=>{
  //  console.log(JSON.stringify(feedBackSelector))
  //  if(feedBackSelector?.status===true){
  //   if(feedBackSelector?.FeedbackContent?.image){
  //     console.log(feedBackSelector?.FeedbackContent?.image);
  //     localStorage.setItem("rateFeedBackImg",feedBackSelector?.FeedbackContent?.image)
  //   }
  //  }
  // },[feedBackSelector]);

  const formDatatablegallery = useMemo(() => {
    return {
      client_path: path,
      domain: window.location.hostname,
    };
  }, [path]);

  useEffect(() => {
    dispatch(getTableGalleryDetail(formDatatablegallery));
  }, [dispatch, formDatatablegallery]);

  const bookingStatusname = useSelector((state) => state?.tableBookGallery);

  useEffect(() => {
    if (bookingStatusname?.response) {
      // console.log(bookingStatusname.response);
      setTableGalleryButton(bookingStatusname.response);

      const bookingStatus = bookingStatusname?.response?.Data?.bookingstatus;

      if (bookingStatus !== undefined) {
        // Store the value in localStorage
        localStorage.setItem("booking_status", bookingStatus); // stores "1" or "0"
      }
    }
  }, [bookingStatusname]);


  return (
    <>
      {
        (
          location.pathname.endsWith("/menu") ||
          location.pathname.endsWith("/checkout")) ? (
          <NavBarMenu
            handleLogout={handleLogout}
            location={location}
            urlLink={getUrlLink}
            getImageUrl={getImageUrl}
            showMealDealMenu={showMealDealMenu}
            showAboutUs={showAboutUs}
            getImageAlt={getImageAlt}
            showGallery={showGallery}
            showBookTable={showBookTable}
            showReview={showReview}
            isLoggedIn={isLoggedIn}
            userData={userData}
            showOrderNowButton={showOrderNowButton}
            searchQuery={searchQuery}
            handleSearchChange={handleSearchChange}
            menuImage={menuImage}
            apiResponse={apiResponse}
          />
        ) : (
          <NavbarDefault
            handleLogout={handleLogout}
            location={location}
            urlLink={getUrlLink}
            getImageUrl={getImageUrl}
            showMealDealMenu={showMealDealMenu}
            showAboutUs={showAboutUs}
            getImageAlt={getImageAlt}
            showGallery={showGallery}
            showBookTable={showBookTable}
            showReview={showReview}
            isLoggedIn={isLoggedIn}
            userData={userData}
            showOrderNowButton={showOrderNowButton}
            searchQuery={searchQuery}
            handleSearchChange={handleSearchChange}
            menuImage={menuImage}
            offerBanner={home}
            apiResponse={apiResponse}
          />
        )
      }

    </>
  );
};
const mapStateToProps = (state) => ({
  response: state.footer.response,
  isLoggedIn: state.userdata.isLoggedIn,
  userData: state.userdata.userData,
  postCode: state.postCode,
  social: state.social.response,
  menuImage: state.menuImage.response,
  home: state.homepage.response
});
const mapDispatchToProps = {
  getFooter,
  getSocial,
  getMenuImage,
  getMealDeal,
  getAboutUs,
  getHomepage,
  getGallery,
  getSignup,
  getReview,
  getFeedBack,
  logout,
  login,
  setLoggedIn,
  getMainTableBooking,
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);

// function NavBarMenu({
//   searchQuery,
//   handleSearchChange,
//   showOrderNowButton,
//   handleLogout,
//   location,
//   userData,
//   handleclick1,
//   urlLink,
//   getImageAlt,
//   getImageUrl,
//   showMealDealMenu,
//   showAboutUs,
//   showGallery,
//   showBookTable,
//   showReview,
//   isLoggedIn,
//   menuImage,
// }) {
//   const { theme } = useContext(ThemeContext);
//   const navigate = useNavigate();
//   // const parsedUrl = new URL(urlLink);
//   const showSearchBar = location.pathname.includes("/menu");
//   // const path = parsedUrl.pathname;
//   const { pathname } = useLocation();

//   const handleClick = (url, event) => {
//     event.preventDefault();
//     const path = new URL(url).pathname;
//     navigate(path);
//   };

//   const { handleActivated, activatedPopup, setActivatedPopup, headerButtonResponse, clientAppLogo } = OrderFlow();
//   const OrderNowStatus = showOrderNowButton && headerButtonResponse?.orderNowButtonStatus === 1;
//   const cartButtonStatusN = headerButtonResponse?.cartButtonStatus === 1;
//   const ContactUsStatus = showOrderNowButton && headerButtonResponse?.contactUsButtonStatus === 1;
//   const menus = [
//     {
//       menu: "Book Now",
//       url: "/#book-nav",
//       as: HashLink,
//       show: showBookTable,
//       // style: { backgroundColor: "orange !important" },
//     },
//     {
//       menu: "Contact Us",
//       url: "/#contact-nav",
//       as: HashLink,
//       show: ContactUsStatus &&
//         !location.pathname.endsWith("/menu") &&
//         !location.pathname.endsWith("/checkout"),
//       // style: { backgroundColor: "orange !important" },
//     },
//     {
//       menu: "Order Now",
//       url: urlLink,
//       redir: (event) => handleClick(urlLink, event),
//       show:
//         OrderNowStatus &&
//         !location.pathname.endsWith("/menu") &&
//         !location.pathname.endsWith("/checkout"),
//       // style: { backgroundColor: "red" },
//     },
//   ];

//   const MenuDatas = [
//     {
//       menu: "Home",
//       url: "/#home-nav",
//       as: HashLink,
//       show: true,
//     },

//     {
//       menu: "Meal Deal",
//       url: "/#meal-deal-page",
//       as: HashLink,
//       show: showMealDealMenu,
//     },
//     {
//       menu: "About Us",
//       url: "/#about-nav",
//       as: HashLink,
//       show: showAboutUs,
//     },
//     {
//       menu: "Gallery",
//       url: "/#gallery-nav",
//       as: HashLink,
//       show: showGallery,
//     },
//     {
//       menu: "Review",
//       url: "/#review-nav",
//       as: HashLink,
//       show: showReview,
//     },
//     {
//       menu: "Contact Us",
//       url: "/#contact-nav",
//       as: HashLink,
//       show: true,
//     },
//   ];
//   const OrderDatas = [
//     {
//       menu: "Meal Deal",
//       url: "/#meal-deal-page",
//       as: HashLink,
//       show:
//         false &&
//         !location.pathname.endsWith("/menu") &&
//         !location.pathname.endsWith("/checkout"),
//     },
//     {
//       menu: "Gallery",
//       url: "/#gallery-nav",
//       as: HashLink,
//       show:
//         false &&
//         !location.pathname.endsWith("/menu") &&
//         !location.pathname.endsWith("/checkout"),
//     },
//     {
//       menu: " Cart",
//       cartvalue: localStorage.getItem("cartQty"),
//       url: urlLink,
//       icon: <GiShoppingBag />,
//       iconcount: (
//         <span className="count">
//           {" "}
//           &#8226; {localStorage.getItem("cartQty")}
//         </span>
//       ),
//       class: "cartBtn",
//       redir: (event) => handleClick(urlLink, event),
//       show:
//         localStorage.getItem("cartQty") != 0 &&
//           !location.pathname.endsWith("/menu") &&
//           !location.pathname.endsWith("/checkout") &&
//           cartButtonStatusN
//           ? true
//           : false,
//     },
//     {
//       menu: "Help",
//       url: "/help",
//       as: HashLink,
//       show: localStorage.getItem("isLoggedIn") === "true" ? true : false,
//     },
//   ];
//   const scrollWithOffset = (el) => {
//     const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
//     const yOffset = -50;
//     window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
//   };


//   return (
//     <>
//       {pathname.endsWith("/menu") ||
//         pathname.endsWith("/about") ||
//         pathname.endsWith("/list") ||
//         pathname.endsWith("/review") ||
//         pathname.endsWith("/checkout") ? (
//         <>
//           <Helmet>
//             <style type="text/css">{`
//         @media only screen and (min-width: 320px) and (max-width: 767px) {
//           nav.main-header .logo img{
//              // visibility:hidden;
//               display:none;
//           }
//           .logo .listiconbackparent{
//             display:none;
//           }
//         }
//     `}</style>
//           </Helmet>
//         </>
//       ) : null}
//       <Navbar collapseOnSelect expand="lg" sticky="top" className="main-header">
//         <Container>
//           <div className="logo">
//             {theme === "light" ? (
//               <>
//                 <Nav.Link as={Link} to={"/"} eventKey={0}>
//                   <img src={clientAppLogo ? clientAppLogo : getImageUrl} alt={getImageUrl} />
//                 </Nav.Link>
//               </>
//             ) : (
//               <>
//                 <Nav.Link as={Link} to={"/"} eventKey={0}>
//                   <img src={clientAppLogo ? clientAppLogo : getImageUrl} alt={getImageUrl} />
//                 </Nav.Link>
//               </>
//             )}
//           </div>

//         </Container>
//       </Navbar>
//       <ActivationPopup />
//     </>
//   );
// }

function NavBarMenu({
  showOrderNowButton,
  handleLogout,
  location,
  userData,
  handleclick1,
  getImageAlt,
  getImageUrl,
  showBookTable,
  isLoggedIn,
  apiResponse
}) {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  // const parsedUrl = new URL(urlLink);
  // const path = parsedUrl.pathname;
  const { pathname } = useLocation();
  // const handleClick = (url, event) => {
  //   event.preventDefault();
  //   const path = new URL(url).pathname;
  //   navigate(path);
  // };
  const handleClick = (url, event) => {
    event.preventDefault();
    // Check if the URL is an external URL
    if (url.startsWith("http://") || url.startsWith("https://")) {
      // For external URLs, use window.location to navigate
      window.location.href = url;
    } else {
      // For internal URLs, use navigate from react-router
      // const path = new URL(url).pathname;
      navigate(url);
    }
  };

  const { handleActivated, headerButtonResponse, cartButtonText, contactUsButtonText,
    orderNowButtonText,
    cartButtonURL, contactUsButtonURL,
    orderNowButtonURL, } = OrderFlow();
  const clientAppLogo = localStorage.getItem("clientAppLogo") ? localStorage.getItem("clientAppLogo") : '';
  const OrderNowStatus = showOrderNowButton && headerButtonResponse?.orderNowButtonStatus === 1;
  const cartButtonStatusN = headerButtonResponse?.cartButtonStatus === 1;
  const ContactUsStatus = showOrderNowButton && headerButtonResponse?.contactUsButtonStatus === 1;
  const booknowLink = `/${localStorage.getItem("path")}/tablebook`;
  const SubscriptionStatus = headerButtonResponse?.subscriptionButtonStatus === 1;

  const menus = [
    {
      menu: "Book Now",
      url: booknowLink,
      as: HashLink,
      show: showBookTable &&
        apiResponse !== "2" &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/tablebook") &&
        !location.pathname.endsWith("/checkout"),
      // style: { backgroundColor: "orange !important" },
    },
    {
      menu: contactUsButtonText,
      url: contactUsButtonURL,
      as: HashLink,
      show: ContactUsStatus &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/checkout"),
      // style: { backgroundColor: "orange !important" },
    },
    {
      menu: orderNowButtonText,
      url: orderNowButtonURL,
      redir: (event) => handleClick(orderNowButtonURL, event),
      show:
        OrderNowStatus &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/checkout"),
      // style: { backgroundColor: "red" },
    }
    // {
    //   menu: cartButtonText,
    //   url: cartButtonURL,
    //   redir: (event) => handleClick(cartButtonURL, event),
    //   show: cartButtonStatusN &&
    //     !location.pathname.endsWith("/menu") &&
    //     !location.pathname.endsWith("/checkout"),
    //   // style: { backgroundColor: "orange !important" },
    // },
  ];
  const OrderDatas = [
    {
      menu: "Meal Deal",
      url: "/#meal-deal-page",
      as: HashLink,
      show:
        false &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/checkout"),
    },
    {
      menu: "Gallery",
      url: "/#gallery-nav",
      as: HashLink,
      show:
        false &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/checkout"),
    },
    {
      menu: cartButtonText,
      cartvalue: localStorage.getItem("cartQty"),
      url: cartButtonURL,
      icon: <GiShoppingBag />,
      iconcount: (
        <span className="count">
          {" "}
          &#8226; {localStorage.getItem("cartQty")}
        </span>
      ),
      class: "cartBtn",
      redir: (event) => handleClick(cartButtonURL, event),
      show:
        localStorage.getItem("cartQty") != 0 &&
          !location.pathname.endsWith("/menu") &&
          !location.pathname.endsWith("/checkout") &&
          cartButtonStatusN
          ? true
          : false,
    },
    {
      menu: "Help",
      url: "/help",
      as: HashLink,
      show: localStorage.getItem("isLoggedIn") === "true" ? true : false,
      class: apiResponse === "2" ? "dy-header-btn" : "nav-link-1",
    },
  ];
  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -50;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  return (
    <>
      {pathname.endsWith("/menu") ||
        pathname.endsWith("/about") ||
        pathname.endsWith("/list") ||
        pathname.endsWith("/review") ||
        pathname.endsWith("/checkout") ? (
        <>
          <Helmet>
            <style type="text/css">{`
        @media only screen and (min-width: 320px) and (max-width: 767px) {
          nav.main-header .logo img{
             // visibility:hidden;
              display:none;
          }
          .logo .listiconbackparent{
            display:none;
          }
        }
            `}</style>
          </Helmet>
        </>
      ) : null}
      <Navbar collapseOnSelect expand="lg" sticky="top" className="main-header">
        <Container>
          <div className="logo 1">
            {theme === "light" ? (
              <>
                <Nav.Link as={Link} to={"/"} eventKey={0}>
                  <img src={clientAppLogo ? clientAppLogo : getImageUrl} alt={getImageAlt} />
                </Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to={"/"} eventKey={0}>
                  <img src={clientAppLogo ? clientAppLogo : getImageUrl} alt={getImageAlt} />
                </Nav.Link>
              </>
            )}
          </div>
          <MenuBtn />
          <Navbar.Collapse id="responsive-navbar-nav">
            {/* {menuImage?.message != 0 && (
                <Nav>
                  <Nav.Link
                    data-Fus="fus-test-MenuLink"
                    as={HashLink}
                    style={{ cursor: "pointer" }}
                    smooth
                    scroll={(el) => scrollWithOffset(el)}
                    to="/menus"
                  >
                    Menu Link
                  </Nav.Link>
                </Nav>
              )} */}
            <Nav>
              {menus.map(
                (menu, index) =>
                  menu.show !== false && (
                    <Nav.Link
                      as={menu.as}
                      key={index}
                      eventKey={6 + index}
                      to={menu.url}
                      onClick={menu.redir}
                      smooth
                      className={apiResponse === "2" ? "dy-header-btn" : "nav-link-1"}
                      scroll={(el) => scrollWithOffset(el)}
                      style={menu.style}
                      data-Fus="fus-test-BookOrdermap"
                    >
                      {menu.img}
                      {menu.menu}
                      {/* <PulseAnim /> */}
                    </Nav.Link>
                  )
              )}
            </Nav>
            <Nav>
              {OrderDatas.map(
                (OrderData, index) =>
                  OrderData.show !== false && (
                    <Nav.Link
                      as={OrderData.as}
                      key={index}
                      eventKey={6 + index}
                      to={OrderData.url}
                      onClick={OrderData.redir}
                      smooth
                      className={OrderData.class}
                      scroll={(el) => scrollWithOffset(el)}
                      data-Fus="fus-test-CardOrderdata"
                    >
                      {OrderData.img}
                      {OrderData.menu}
                      {/* <PulseAnim /> */}
                    </Nav.Link>
                  )
              )}
              {isLoggedIn ? (
                <NavDropdown
                  title={
                    <span className={apiResponse === "2" ? "title-color" : ""}>
                      Hi {userData.fname}
                    </span>
                  }
                  className={apiResponse === "2" ? "dy-header-btn" : "nav-link-1"}
                >
                  <NavDropdown.Item
                    as={Link}
                    eventKey="5"
                    to="/myaccount"
                    onClick={handleclick1}
                    data-Fus="fus-test-Myaccountdata">
                    <FaUserCircle /> My Account
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    eventKey="6"
                    as={Link}
                    to="/myaccount/wallet"
                  >
                    <MdAccountBalanceWallet /> Wallet
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    eventKey="6"
                    as={Link}
                    to={!location.pathname.includes("/menu") ? "/" : "#"}
                    onClick={handleLogout}
                  >
                    <IoMdExit /> Logout
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <>
                  {pathname.endsWith("/menu") ||
                    pathname.endsWith("/tablebook") ? (
                    <>
                      <SignIn isLoggedIn={isLoggedIn} />
                    </>
                  ) : null}
                  {SubscriptionStatus &&
                    <Subscription />
                  }
                </>
              )}
            </Nav>
            <Nav></Nav>

            <Nav>
              {isLoggedIn && (
                <Nav.Link
                  eventKey="link-1"
                  className={` ${apiResponse === "2" ?
                    "dy-header-btn d-inline-block d-lg-none" :
                    "nav-link-1 d-inline-block d-lg-none"}`}
                  style={{ margin: "8px 0px 0px 0px" }}
                  onClick={handleActivated}
                >
                  Account Deletion
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <ActivationPopup />
    </>
  );
}

function NavbarDefault({
  showOrderNowButton,
  handleLogout,
  location,
  userData,
  handleclick1,
  urlLink,
  getImageUrl,
  getImageAlt,
  showBookTable,
  isLoggedIn,
  apiResponse
}) {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { handleActivated, headerButtonResponse,
    cartButtonText, 
    contactUsButtonText, 
    franchiseButtonText, 
    orderNowButtonText,
    cartButtonURL,franchiseButtonURL,
    contactUsButtonURL,
    orderNowButtonURL } = OrderFlow();
  const clientAppLogo = localStorage.getItem("clientAppLogo") ? localStorage.getItem("clientAppLogo") : '';
  const OrderNowStatus1 = showOrderNowButton && headerButtonResponse?.orderNowButtonStatus === 1;
  const CartButtonStatus1 = headerButtonResponse?.cartButtonStatus === 1;
  const ContactUsStatus1 = showOrderNowButton && headerButtonResponse?.contactUsButtonStatus === 1;
  const FranchiseStatus1 = showOrderNowButton && headerButtonResponse?.franchiseButtonStatus === 1;
  const SubscriptionStatus1 = headerButtonResponse?.subscriptionButtonStatus === 1;

  // const handleClick = (url, event) => {
  //   event.preventDefault();
  //   const path = new URL(url).pathname;
  //   navigate(path);
  // };
  const booknowLink = `/${localStorage.getItem("path")}/tablebook`;
  const handleClick = (url, event) => {
    event.preventDefault();
    // Check if the URL is an external URL
    if (url.startsWith("http://") || url.startsWith("https://")) {
      // For external URLs, use window.location to navigate
      window.location.href = url;
    } else {
      // For internal URLs, use navigate from react-router
      // const path = new URL(url).pathname;
      navigate(url);
    }
  };
  const handleCartClick = () => {
    const path = new URL(urlLink).pathname;
    navigate(path);
  };
  const menus = [
    {
      menu: "Book Now",
      url: booknowLink,
      as: HashLink,
      show: showBookTable &&
        apiResponse !== "2" &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/tablebook") &&
        !location.pathname.endsWith("/checkout"),
      // style: { backgroundColor: "orange !important" },
    },
    {
      menu: orderNowButtonText,
      url: orderNowButtonURL,
      redir: (event) => handleClick(orderNowButtonURL, event),
      show:
        OrderNowStatus1 &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/tablebook") &&
        !location.pathname.endsWith("/checkout")
      // style: { backgroundColor: "red" },
    },
    {
      menu: contactUsButtonText,
      url: contactUsButtonURL,
      as: HashLink,
      show: ContactUsStatus1 &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/tablebook") &&
        !location.pathname.endsWith("/checkout")
    },
    {
      menu: franchiseButtonText,
      url: franchiseButtonURL,
      redir: (event) => handleClick(franchiseButtonURL, event),
      show: FranchiseStatus1 &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/tablebook") &&
        !location.pathname.endsWith("/checkout")
    },
  ];

  const OrderDatas = [
    {
      menu: "Meal Deal",
      url: "/#meal-deal-page",
      as: HashLink,
      show:
        false &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/tablebook") &&
        !location.pathname.endsWith("/checkout")
    },
    {
      menu: "Gallery",
      url: "/#gallery-nav",
      as: HashLink,
      show:
        false &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/tablebook") &&
        !location.pathname.endsWith("/checkout")
    },
    {
      menu: cartButtonText,
      cartvalue: localStorage.getItem("cartQty"),
      url: cartButtonURL,
      icon: <GiShoppingBag />,
      iconcount: (
        <span className="count">
          {" "}
          &#8226; {localStorage.getItem("cartQty")}
        </span>
      ),
      class: apiResponse === "2" ? "dy-header-btn" : "cartBtn",

      redir: (event) => handleClick(cartButtonURL, event),
      show:
        localStorage.getItem("cartQty") != 0 &&
          !location.pathname.endsWith("/menu") &&
          !location.pathname.endsWith("/tablebook") &&
          !location.pathname.endsWith("/checkout") &&
          CartButtonStatus1
          ? true
          : false,
    },
    {
      menu: "Help",
      url: "/help",
      as: HashLink,
      show: localStorage.getItem("isLoggedIn") === "true" ? true : false,
      class: apiResponse === "2" ? "dy-header-btn" : "nav-link-1 ",
    },
  ];
  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -50;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  return (
    <>
      {pathname.endsWith("/menu") ||
        pathname.endsWith("/about") ||
        pathname.endsWith("/list") ||
        pathname.endsWith("/review") ||
        pathname.endsWith("/checkout") ? (
        <>
          <Helmet>
            <style type="text/css">{`
        @media only screen and (min-width: 320px) and (max-width: 767px) {
          nav.main-header .logo img{
             // visibility:hidden;
              display:none;
          }
          .logo .listiconbackparent{
            display:none;
          }
        }
    `}</style>
          </Helmet>
        </>
      ) : null}
      {/* {pathname.endsWith("/") && <OfferBanner offerBanner={offerBanner} />} */}
      <Navbar collapseOnSelect expand="lg" sticky="top" className="main-header">
        <Container>
          <div className="logo 2">
            {theme === "light" ? (
              <>
                <Nav.Link as={Link} to={"/"} eventKey={0}>
                  <img src={clientAppLogo ? clientAppLogo : getImageUrl} alt={getImageAlt} />
                </Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to={"/"} eventKey={0}>
                  <img src={clientAppLogo ? clientAppLogo : getImageUrl} alt={getImageAlt} />
                </Nav.Link>
              </>
            )}
          </div>
          {apiResponse && apiResponse !== "2" &&
            <div
              className="cartmobile d-inline-block d-lg-none"
              onClick={handleCartClick}
            >
              <GiShoppingBag />
              {localStorage.getItem("cartQty") > 0 && (
                <span className="counts">{localStorage.getItem("cartQty")}</span>
              )}
            </div>
          }


          <MenuBtn />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav>
              {/* <Nav.Link
                className="d-inline-block"
                style={{ background: 'none',display:'none' }}
                onClick={handleCurrencyPopup}
              >
                {currency}
              </Nav.Link> */}
            </Nav>
            {/* {menuImage?.message != 0 && (
              <Nav>
                <Nav.Link
                  data-Fus="fus-test-MenuLink"
                  as={HashLink}
                  style={{ cursor: "pointer" }}
                  smooth
                  scroll={(el) => scrollWithOffset(el)}
                  to="/menus"
                >
                  Menu Link
                </Nav.Link>
              </Nav>
            )} */}
            <Nav>
              {menus.map(
                (menu, index) =>
                  menu.show !== false && (
                    <Nav.Link
                      as={menu.as}
                      key={index}
                      eventKey={6 + index}
                      to={menu.url}
                      onClick={menu.redir}
                      smooth
                      className={`${apiResponse === "2" ? "dy-header-btn" : "nav-link-1"}`}
                      scroll={(el) => scrollWithOffset(el)}
                      style={menu.style}
                      data-Fus="fus-test-BookOrdermap"
                    >
                      {menu.img}
                      {menu.menu}
                      {/* <PulseAnim /> */}
                    </Nav.Link>
                  )
              )}
            </Nav>
            <Nav>
              {OrderDatas.map(
                (OrderData, index) =>
                  OrderData.show !== false && (
                    <Nav.Link
                      as={OrderData.as}
                      key={index}
                      eventKey={6 + index}
                      to={OrderData.url}
                      onClick={OrderData.redir}
                      smooth
                      className={OrderData.class}
                      scroll={(el) => scrollWithOffset(el)}
                      data-Fus="fus-test-CardOrderdata"
                    >
                      {/* {OrderData.img}
                      {OrderData.menu} */}
                      {OrderData.icon}
                      {OrderData.menu}
                      {OrderData.iconcount}
                      {/* <PulseAnim /> */}
                    </Nav.Link>
                  )
              )}
              {isLoggedIn ? (
                <NavDropdown
                  title={
                    <span className={apiResponse === "2" ? "title-color" : ""}>
                      Hi {userData.fname}
                    </span>
                  }
                  className={apiResponse === "2" ? "dy-header-btn" : "nav-link-1"}
                >
                  <NavDropdown.Item
                    as={Link}
                    eventKey="5"
                    to="/myaccount"
                    onClick={handleclick1}
                    data-Fus="fus-test-Myaccountdata"
                  >
                    <FaUserCircle /> My Account
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    eventKey="6"
                    as={Link}
                    to="/myaccount/wallet"
                  >
                    <MdAccountBalanceWallet /> Wallet
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    eventKey="7"
                    as={Link}
                    to={!location.pathname.includes("/menu") ? "/" : "#"}
                    onClick={handleLogout}>
                    <IoMdExit /> Logout
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <>
                  {pathname.endsWith("/menu") ||
                    pathname.endsWith("/tablebook") ?
                    (<>
                      <SignIn isLoggedIn={isLoggedIn} />
                    </>) : null}
                  {SubscriptionStatus1 &&
                    <Subscription />
                  }
                </>
              )}
            </Nav>
            <Nav>
              <Nav.Link
                eventKey="link-1"
                // className="d-inline-block d-lg-none"
                className={`${apiResponse === "2" ? "dy-header-btn d-inline-block d-lg-none" : "nav-link-1 d-inline-block d-lg-none"}`}
                style={{ margin: "8px 0px 0px 0px" }}
                onClick={handleActivated}
              >
                Account Deletion
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <ActivationPopup />
      <PopupCurrency />
    </>
  );
}

